// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc423adc","453":"ed5a4ebc","732":"e7e65976"}[chunkId] + ".chunk.js";
};